import { DrawerBody as FluentDrawerBody } from "@fluentui/web-components";
/**
 * DrawerBody
 * @summary A component that provides a drawer body for displaying content in a side panel.
 *
 * @example
 * ```html
 * <fabric-drawer-body>
 *   <span slot="title">Title Content</span>
 *   <span slot="close">Close Button</span>
 *   Main Content
 *   <div slot="footer">Footer Content</div>
 * </fabric-drawer-body>
 * ```
 *
 * @slot title - The title slot.
 * @slot close - The close button slot.
 * @slot - The default content slot.
 * @slot footer - The footer slot.
 *
 * @csspart header - The header part of the drawer.
 * @csspart content - The content part of the drawer.
 * @csspart footer - The footer part of the drawer.
 *
 * @extends FluentDrawerBody
 * @tagname fabric-drawer-body
 * @public
 */
export class DrawerBody extends FluentDrawerBody {
}
//# sourceMappingURL=drawer-body.js.map